import { useState } from 'react';
import { ChatBubbleOvalLeftIcon } from '@heroicons/react/24/outline';
import { InteractionsResponse } from '../../../store/backendApi';
import { LikeButton } from '../LikeButton';
import { CommentsModal } from './CommentsModal';
import { Button } from '../../../components/Button';

export interface Comment {
  name?: string;
  userId?: string;
  body: string;
  id: string;
  createdAt: string;
}

export interface CommentTextFieldProps {
  tripId: string;
  storyId: string;
  comments: Comment[] | undefined;
  linkSecret: string | null;
  interactions: InteractionsResponse | undefined;
  isOwner: boolean;
}

export const CommentSection = (props: CommentTextFieldProps) => {
  const [open, setOpen] = useState(false);

  const comments =
    props.comments
      ?.slice()
      .sort((c1, c2) => new Date(c2.createdAt).getTime() - new Date(c1.createdAt).getTime()) ?? [];
  const commentCount = comments.length;

  const story = props.interactions?.stories.find((st) => st.storyId === props.storyId);
  const likes = story?.likes || [];
  const likeCount = likes.length;

  return (
    <>
      <div className="w-full flex items-center justify-center gap-8">
        <div className="flex flex-col items-center gap-1">
          <LikeButton
            tripId={props.tripId}
            storyId={props.storyId}
            linkSecret={props.linkSecret}
            interactions={props.interactions}
          />
          <div className="text-sm text-main">{likeCount}</div>
        </div>

        <Button
          variant="ghost"
          onClick={() => setOpen(true)}
          className="flex flex-col items-center gap-1 group p-0 h-auto active:scale-90"
          aria-label="Comments"
        >
          <ChatBubbleOvalLeftIcon className="w-7 h-7 text-main group-hover:text-muted" />
          <div className="text-sm text-main">{commentCount}</div>
        </Button>
      </div>

      <CommentsModal
        open={open}
        onClose={() => setOpen(false)}
        comments={comments}
        tripId={props.tripId}
        storyId={props.storyId}
        linkSecret={props.linkSecret}
        isOwner={props.isOwner}
      />
    </>
  );
};
